enum Environment {
  Production = 'PRD',
  Staging = 'STG',
  Development = 'DEV',
}
export default Environment;
